export function capitalize(text) {
    if (!text || text.length === 0)
        return text;

    return text.charAt(0).toUpperCase() + text.slice(1);
}